/* =========================================================
   Pawan River — theme interactions
   Vanilla JS, no dependencies. Progressive enhancement.
   ========================================================= */
(function () {
  'use strict';

  var root = document.documentElement;

  /* ---------- Helpers ---------- */
  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $all(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function on(el, ev, fn) { if (el) el.addEventListener(ev, fn); }
  var formatMoney = function (cents) {
    try {
      return (window.Shopify && Shopify.currency ? Shopify.currency.active + ' ' : '$') +
        (cents / 100).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    } catch (e) { return '$' + (cents / 100).toFixed(2); }
  };

  /* ---------- Sticky header shadow ---------- */
  var header = $('.site-header');
  function onScroll() {
    if (!header) return;
    header.classList.toggle('is-scrolled', window.scrollY > 12);
  }
  on(window, 'scroll', onScroll); onScroll();

  /* ---------- Mobile menu ---------- */
  var mobileMenu = $('.mobile-menu');
  var overlay = $('.overlay');
  function openMenu() { if (mobileMenu) { mobileMenu.classList.add('is-open'); document.body.style.overflow = 'hidden'; } }
  function closeMenu() { if (mobileMenu) { mobileMenu.classList.remove('is-open'); document.body.style.overflow = ''; } }
  on($('.header__mobile-toggle'), 'click', openMenu);
  on($('.mobile-menu__close'), 'click', closeMenu);
  $all('.mobile-menu nav a').forEach(function (a) { on(a, 'click', closeMenu); });

  /* ---------- Cart drawer ---------- */
  var cartDrawer = $('.cart-drawer');
  function openCart() {
    if (!cartDrawer) return;
    cartDrawer.classList.add('is-open');
    if (overlay) overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    refreshCart();
  }
  function closeCart() {
    if (!cartDrawer) return;
    cartDrawer.classList.remove('is-open');
    if (overlay) overlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }
  $all('[data-cart-open]').forEach(function (b) { on(b, 'click', function (e) { e.preventDefault(); openCart(); }); });
  on($('.cart-drawer__close'), 'click', closeCart);
  on(overlay, 'click', closeCart);
  on(document, 'keydown', function (e) { if (e.key === 'Escape') { closeCart(); closeMenu(); } });

  /* ---------- Cart data & rendering ---------- */
  function renderCart(cart) {
    var wrap = $('.cart-drawer__items');
    var countEls = $all('[data-cart-count]');
    countEls.forEach(function (el) { el.textContent = cart.item_count; el.classList.toggle('is-empty', cart.item_count === 0); });
    var subtotalEl = $('[data-cart-subtotal]');
    if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);

    if (!wrap) return;
    if (cart.item_count === 0) {
      wrap.innerHTML = '<div class="cart-empty"><p>Your cart is quiet for now.</p></div>';
      var foot = $('.cart-drawer__foot'); if (foot) foot.style.display = 'none';
      return;
    }
    var footEl = $('.cart-drawer__foot'); if (footEl) footEl.style.display = '';
    wrap.innerHTML = cart.items.map(function (item) {
      var plan = item.selling_plan_allocation ? '<div class="cart-line__meta">' + item.selling_plan_allocation.selling_plan.name + '</div>' : '';
      var props = '';
      if (item.properties) {
        Object.keys(item.properties).forEach(function (k) {
          if (k.charAt(0) === '_' || !item.properties[k]) return;
          props += '<div class="cart-line__meta">' + k + ': ' + item.properties[k] + '</div>';
        });
      }
      var img = item.image ? '<img src="' + item.image.replace(/(\.[^.]+)$/, '_160x$1') + '" alt="' + item.product_title + '">' : '<span></span>';
      return '<div class="cart-line" data-key="' + item.key + '">' +
        img +
        '<div><div class="cart-line__title">' + item.product_title + '</div>' + plan + props +
        '<div class="qty"><button data-qty-down aria-label="Decrease">–</button><input type="text" value="' + item.quantity + '" data-qty-input readonly><button data-qty-up aria-label="Increase">+</button></div>' +
        '<button class="link-underline" data-remove style="margin-top:.6rem;border-color:transparent;font-size:.72rem;">Remove</button></div>' +
        '<div class="cart-line__meta">' + formatMoney(item.final_line_price) + '</div>' +
        '</div>';
    }).join('');

    // bind qty + remove
    $all('.cart-line', wrap).forEach(function (line) {
      var key = line.getAttribute('data-key');
      var qty = parseInt($('[data-qty-input]', line).value, 10);
      on($('[data-qty-up]', line), 'click', function () { changeItem(key, qty + 1); });
      on($('[data-qty-down]', line), 'click', function () { changeItem(key, Math.max(0, qty - 1)); });
      on($('[data-remove]', line), 'click', function () { changeItem(key, 0); });
    });
  }

  function refreshCart() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(renderCart).catch(function () {});
  }

  function changeItem(key, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(function (r) { return r.json(); }).then(renderCart).catch(function () {});
  }

  /* ---------- Add to cart (AJAX) ---------- */
  $all('form[action="/cart/add"], form[action^="/cart/add"]').forEach(function (form) {
    on(form, 'submit', function (e) {
      e.preventDefault();
      var btn = form.querySelector('[type="submit"]');
      if (btn) { btn.setAttribute('disabled', 'disabled'); btn.dataset.label = btn.textContent; btn.textContent = 'Adding…'; }
      fetch('/cart/add.js', { method: 'POST', body: new FormData(form), headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function () {
          if (btn) { btn.removeAttribute('disabled'); btn.textContent = btn.dataset.label || 'Add to cart'; }
          openCart();
        }).catch(function () {
          if (btn) { btn.removeAttribute('disabled'); btn.textContent = btn.dataset.label || 'Add to cart'; }
        });
    });
  });

  /* ---------- Gift note persistence ---------- */
  var giftNote = $('[data-gift-note]');
  if (giftNote) {
    var saveNote = debounce(function () {
      fetch('/cart/update.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ note: giftNote.value })
      });
    }, 500);
    on(giftNote, 'input', saveNote);
  }
  function debounce(fn, wait) { var t; return function () { var a = arguments, c = this; clearTimeout(t); t = setTimeout(function () { fn.apply(c, a); }, wait); }; }

  /* ---------- Accordions ---------- */
  $all('.accordion__head').forEach(function (head) {
    on(head, 'click', function () {
      var item = head.closest('.accordion__item');
      var body = $('.accordion__body', item);
      var open = item.classList.toggle('is-open');
      body.style.maxHeight = open ? body.scrollHeight + 'px' : null;
      head.setAttribute('aria-expanded', open);
    });
  });

  /* ---------- Ritual (selling plan) toggle ---------- */
  $all('[data-ritual-toggle]').forEach(function (group) {
    var options = $all('.ritual-toggle__option', group);
    var planInput = group.querySelector('[data-selling-plan-input]') || document.querySelector('[data-selling-plan-input]');
    options.forEach(function (opt) {
      on(opt, 'click', function () {
        options.forEach(function (o) { o.classList.remove('is-active'); });
        opt.classList.add('is-active');
        var radio = $('input[type=radio]', opt); if (radio) radio.checked = true;
        var plan = opt.getAttribute('data-plan-id') || '';
        if (planInput) planInput.value = plan;
      });
    });
  });

  /* ---------- Reveal on scroll ---------- */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-visible'); io.unobserve(en.target); } });
    }, { threshold: 0.12 });
    $all('.reveal').forEach(function (el) { io.observe(el); });
  } else {
    $all('.reveal').forEach(function (el) { el.classList.add('is-visible'); });
  }

  /* ---------- Klaviyo newsletter (AJAX) ---------- */
  $all('[data-klaviyo-form]').forEach(function (form) {
    on(form, 'submit', function (e) {
      var key = form.getAttribute('data-klaviyo-key');
      var list = form.getAttribute('data-klaviyo-list');
      var msg = form.querySelector('[data-form-msg]');
      // If Klaviyo not configured, fall back to Shopify customer form (native submit)
      if (!key || !list) return; // allow normal submit
      e.preventDefault();
      var email = form.querySelector('input[type=email]').value;
      var body = 'g=' + encodeURIComponent(list) + '&$fields=%24source&%24source=Pawan+River+Letter&email=' + encodeURIComponent(email);
      fetch('https://manage.kmail-lists.com/ajax/subscriptions/subscribe', {
        method: 'POST', headers: { 'Content-Type': 'application/x-www-form-urlencoded', 'Accept': 'application/json' },
        body: 'g=' + encodeURIComponent(list) + '&email=' + encodeURIComponent(email)
      }).then(function (r) { return r.json(); }).then(function () {
        if (msg) msg.textContent = form.getAttribute('data-success') || 'Thank you.';
        form.reset();
      }).catch(function () { if (msg) msg.textContent = form.getAttribute('data-error') || 'Please try again.'; });
    });
  });

  refreshCart();
})();
